module.exports = __webpack_public_path__ + "img/delivery-3.6bce1dc7.svg";